import {Component, Input} from '@angular/core';
import {NavigationStart, Router} from "@angular/router";
import {Alert} from "./alert.model";
import {AlertTypes} from "./alert-types";
import {Subscription} from "rxjs";
import {AlertService} from "./alert.service";
import {fuseAnimations} from "../../../../@fuse/animations";
import {state} from "@angular/animations";

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
    animations: fuseAnimations
})
export class AlertComponent {

    @Input() id = 'default-alert';
    @Input() fade = true;

    alerts: Alert[] = [];
    alertSubscription: Subscription;
    routeSubscription: Subscription;
    timeOut: number = 5000;

    constructor(private router: Router, private alertService: AlertService) { }

    ngOnInit() {
        this.alertSubscription = this.alertService.onAlert(this.id)
            .subscribe(alert => {
                    if (!alert.message) {
                        this.alerts = [];
                        return;
                    }

                    this.alerts.push(alert);

                    if (alert.autoClose) {
                        setTimeout(() => this.removeAlert(alert), this.timeOut);
                    }
                }
            );

        // clear alerts on location change
        this.routeSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.alertService.clear(this.id);
            }
        });
    }

    ngOnDestroy() {
        // unsubscribe to avoid memory leaks
        this.alertSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
    }

    removeAlert(alert: Alert) {
        if (!this.alerts.includes(alert)) return;

        if (this.fade) {
            this.alerts.find(x => x === alert).fade = true;

            setTimeout(() => {
                this.alerts = this.alerts.filter(x => x !== alert);
            }, 250);
        } else {
            this.alerts = this.alerts.filter(x => x !== alert);
        }
    }

    getDefaultTitle(alertType: string): string {
        switch (alertType) {
            case AlertTypes.ERROR:
                return 'Erro';
            case AlertTypes.INFO:
                return 'Informação';
            case AlertTypes.SUCCESS:
                return 'Sucesso';
            case AlertTypes.WARNING:
                return 'Aviso';
            default:
                return 'Notificação';
        }
    }

    protected readonly state = state;
}
